import React, { useEffect, useState } from 'react';
import SettingsDialog, { SETTINGS_TAB_MAX } from '../SettingsDialog';

/**
 * Hosts the Settings dialog for the whole app shell. Anything can open it with
 * `window.dispatchEvent(new Event('quillai:open-settings'))`, or a CustomEvent whose
 * `detail.initialTab` (0 to SETTINGS_TAB_MAX) picks the tab.
 * @returns {JSX.Element} Settings dialog.
 */
export default function SettingsHost() {
  const [open, setOpen] = useState(false);
  const [initialTab, setInitialTab] = useState(0);

  useEffect(() => {
    const onOpen = (event) => {
      const tab = event instanceof CustomEvent && typeof event.detail?.initialTab === 'number' ? event.detail.initialTab : 0;
      setInitialTab(Number.isInteger(tab) && tab >= 0 && tab <= SETTINGS_TAB_MAX ? tab : 0);
      setOpen(true);
    };
    window.addEventListener('quillai:open-settings', onOpen);
    return () => window.removeEventListener('quillai:open-settings', onOpen);
  }, []);

  return (
    <SettingsDialog
      open={open}
      initialTab={initialTab}
      onClose={() => {
        setOpen(false);
        setInitialTab(0);
      }}
    />
  );
}
